import React__default from 'react';
import { Topic } from '../topic.js';

var modalOpenTopic = new Topic(); // TODO(ayase): 待实现可 createPortal 的 Modal 之后替换该组件的实现

var DeleteDialog = function DeleteDialog(_ref) {
  var modalKey = _ref.modalKey,
      onConfirm = _ref.onConfirm,
      onCancel = _ref.onCancel,
      children = _ref.children;
  var handleModalOpenTopic = React__default.useCallback(function (modalKeyOpened) {
    if (modalKeyOpened !== modalKey) {
      onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    }
  }, [modalKey, onCancel]);
  React__default.useEffect(function () {
    modalOpenTopic.notify(modalKey);
    modalOpenTopic.register(handleModalOpenTopic);
    return function () {
      modalOpenTopic.unregister(handleModalOpenTopic);
    };
  }, [modalKey, handleModalOpenTopic]);

  var handleConfirm = function handleConfirm() {
    if (onConfirm) {
      onConfirm();
    }
  };

  var handleCancel = function handleCancel() {
    if (onCancel) {
      onCancel();
    }
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "delete-box"
  }, /*#__PURE__*/React__default.createElement("span", null, children), /*#__PURE__*/React__default.createElement("div", {
    className: "btn-row"
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: handleConfirm,
    className: "btn-red"
  }, "\u786E\u5B9A"), /*#__PURE__*/React__default.createElement("button", {
    className: "btn-white",
    onClick: handleCancel
  }, "\u53D6\u6D88")));
};

export { DeleteDialog };
